import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import { Text } from 'atoms';
import { AntdTable } from 'components/custom-table/Style';
import { TableWrapper } from './CreateVehicleTypePageV2.styles';

const getTableColumns = (handleView) => [
	{
		title: 'Maker',
		dataIndex: 'maker',
		key: 'maker',
		render: (text) => <Text>{text || '-'}</Text>,
	},
	{
		title: 'Model Name',
		dataIndex: 'modelName',
		key: 'modelName',
		render: (text) => <Text>{text || '-'}</Text>,
	},
	{
		title: 'Capacity',
		dataIndex: 'capacity',
		key: 'capacity',
		render: (text) => <Text>{text || '-'}</Text>,
	},
	{
		title: 'Length',
		dataIndex: 'length',
		key: 'length',
		render: (text) => <Text>{text || '-'}</Text>,
	},
	{
		title: 'Temp Controlled',
		dataIndex: 'tempControlled',
		key: 'tempControlled',
		render: (text) => {
			// Convert boolean or string to Yes/No
			if (text === true || text === 'true' || text === 'yes' || text === 'Yes') {
				return <Text>Yes</Text>;
			}
			if (text === false || text === 'false' || text === 'no' || text === 'No') {
				return <Text>No</Text>;
			}
			return <Text>-</Text>;
		},
	},
	{
		title: 'Fuel Type',
		dataIndex: 'fuelType',
		key: 'fuelType',
		render: (text) => <Text>{text || '-'}</Text>,
	},
	{
		title: 'Driver Mode',
		dataIndex: 'driverMode',
		key: 'driverMode',
		render: (text) => <Text>{text || '-'}</Text>,
	},
	{
		title: 'Actions',
		key: 'actions',
		align: 'center',
		render: (_, record) => (
			<Button
				type="text"
				icon={<EyeOutlined />}
				onClick={() => handleView(record)}
				style={{ color: '#1e293b', fontSize: '18px' }}
			/>
		),
	},
];

function VehicleDetailsTable({ vehicleDetails, handleView }) {
	return (
		<>
			<Text fontSize="26px" fontWeight="600" mt={4} mb={4} display="block">
				Vehicle Details
			</Text>
			<TableWrapper>
				<AntdTable
					rowKey="key"
					columns={getTableColumns(handleView)}
					dataSource={vehicleDetails}
					pagination={false}
				/>
			</TableWrapper>
		</>
	);
}

VehicleDetailsTable.propTypes = {
	vehicleDetails: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.string,
			maker: PropTypes.string,
			modelName: PropTypes.string,
			capacity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
			length: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
			tempControlled: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
			fuelType: PropTypes.string,
			driverMode: PropTypes.string,
		})
	).isRequired,
	handleView: PropTypes.func.isRequired,
};

export default VehicleDetailsTable;
